var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{ref:"input",staticClass:"vs-inputx vs-input--input normal",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"focus":_vm.selectAll,"blur":_vm.formatValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }